export default {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  contract: {},
  contracts: [],
  loan: {},
  loans: [],
  loanDetail: {},
  loanDetails: [],
  restructuringDetail: {},
  restructuringDetails: [],
  transaction: {},
  transactions: [],
  payment: {},
  payments: [],
  paymentRoundDetails: [],
  paymentAmountDetailNormal: {},
  paymentAmountDetailOutstanding: {},
  paymentAmountDetailClose: {},
  qrPayment: {},
}
